module.exports = __webpack_public_path__ + "f2a05769e8257b01776c268d53af0b7d.svg";